module.exports = __webpack_public_path__ + "img/06.4a6037b4.png";